import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

import { formatServiceType } from './connector-format.util'
import { ConnectorProviderIcon } from './connector-provider-icon.atom'
import { ConnectorStatusBadge } from './connector-status-badge.atom'

export interface ConnectorProviderHeaderProps {
  providerSlug: string
  providerDisplayName: string
  serviceTypeList: string[]
  isConnected: boolean
  connectedAccountEmail: string | null
  className?: string
}

/**
 * Header section displaying provider identity, service types, and connection status.
 */
export const ConnectorProviderHeader: React.FC<ConnectorProviderHeaderProps> = ({
  providerSlug,
  providerDisplayName,
  serviceTypeList,
  isConnected,
  connectedAccountEmail,
  className,
}: ConnectorProviderHeaderProps): ReactNode => (
  <div className={cn('connector-provider-header flex items-center gap-4', className)}>
    <ConnectorProviderIcon providerSlug={providerSlug} size="lg" />
    <div className="flex-1">
      <div className="flex items-center gap-3">
        <h2 className="text-lg font-semibold">{providerDisplayName}</h2>
        <ConnectorStatusBadge isConnected={isConnected} />
      </div>
      <p className="text-muted-foreground text-sm">
        {serviceTypeList.map(formatServiceType).join(', ')}
        {isConnected && connectedAccountEmail && (
          <>
            {' · '}
            <span className="text-foreground font-medium">{connectedAccountEmail}</span>
          </>
        )}
      </p>
    </div>
  </div>
)

ConnectorProviderHeader.displayName = 'ConnectorProviderHeader'
